import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class wmWidth extends wmBase {
    constructor(options: widgetOption[]) {
        super();
        this.options = options;
    }

    build(): string {
        const uniqValues: number[] = [];

        for (let i = 0; i < this.options.length; i++) {
            let uniqFound = false;
            for (let k = 0; k < uniqValues.length; k++) {
                if (uniqValues[k] === this.options[i].value) {
                    uniqFound = true;
                }
            }
            const val = Number(this.options[i].value);
            if (!Number.isNaN(val) && !uniqValues.includes(val)) {
                uniqValues.push(val);
            }
        }

        return `
            <div class="wm_dividor"></div>
            <div class="wm_width">
                <input type="range" class="wm_width_range" value="${uniqValues[0] ?? 1}" min="1" max="15"/>
            </div>
        `;
    }

    init(): void {
        const range = document.querySelector(".wm_width_range") as HTMLInputElement;
        range.addEventListener("input", this.rangeChange, false);
        range.addEventListener("change", this.rangeChangeLast, false);
    }

    rangeChange = (e: Event): void => {
        const item = getTarget(e, "wm_width_range") as HTMLInputElement;
        this.applyValue(this.options, Number.parseInt(item.value, 10), false, false);
        this.currentLineWidth = Number(item.value);
    };

    rangeChangeLast = (e: Event): void => {
        const item = getTarget(e, "wm_width_range") as HTMLInputElement;
        this.applyValue(this.options, Number.parseInt(item.value, 10), false);
        this.currentLineWidth = Number(item.value);
    };

    name = "wm_width";
    aliases: number[] = [3, 6, 9];
    options: widgetOption[] = [];
    isStriked = false;
    currentLineWidth?: number;
}
